import React from 'react';
import BehavioralInsightsTab from './BehavioralInsightsTab';
import { useTranslation } from 'react-i18next';

interface RecommendationsSectionProps {
  recommendations: any[];
  onScheduleCall: () => void;
}

export const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({
  recommendations,
  onScheduleCall
}) => {
  const { t } = useTranslation();
  
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">{t('dashboard.healthInsights.title')}</h2>
      
      <div>
        <div className="flex items-center gap-2 mb-4">
          <h3 className="text-lg font-medium text-gray-900">{t('dashboard.healthInsights.behavioralPatterns')}</h3>
        </div>
        
        <BehavioralInsightsTab insights={recommendations} />
      </div>
    </div>
  );
};

export default RecommendationsSection;
